import SubmissionError from '../../../../../../error/SubmissionError'
import fetch from '../../../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'

export const reset = ({ commit }) => {
  commit(types.RESET)
}

export const retrieve = ({ commit }, id) => {
  commit(types.TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_RETRIEVED, data)
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        text: e.message,
        showConfirmButton: true,
        timer: 6000
      })
      console.log(e.message)
      // commit(types.SET_ERROR, e.message)
    })
}

export const update = ({ commit, state }) => {
  commit(types.SET_ERROR, '')
  commit(types.TOGGLE_LOADING)

  return fetch(state.retrieved['@id'], {
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/ld+json' }),
    body: JSON.stringify(state.retrieved)
  })
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_UPDATED, data)
      Vue.prototype.$Swal({ // show notification with success
        type: 'success',
        title: Vue.prototype.$lang.t('notifications.update.updatedTitle'),
        showConfirmButton: false,
        timer: 2500
      })
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        // commit(types.SET_ERROR, e.errors._error)
        let errors = ''
        for (let key in e.errors) {
          if (key !== '_error') {
            errors += Vue.prototype.$lang.t('views.excmsla.form.' + key) + ' -  ' + e.errors[key] + '<br />'
          }
        }
        Vue.prototype.$Swal({
          type: 'error',
          title: Vue.prototype.$lang.t('notifications.update.errorTitle'),
          html: errors,
          showConfirmButton: true
        })
        return
      }
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.update.errorTitle'),
        text: e,
        showConfirmButton: true,
        timer: 6000
      })
      // eslint-disable-next-line
      // commit(commit(types.SET_ERROR, e.errors._error))
    })
}

export const updateRetrieved = ({ commit }, updated) => {
  commit(types.UPDATE_RETRIEVED, updated)
}
